class PushCartRecentlyViewed extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['carousel', 'fragmentinjection']
  }

  static get requiredExternalElements () {
    return ['fallbackView']
  }

  constructor () {
    super()
    this.sectionId = 'async-push-cart-product-card'
    this.initialised()
  }

  initialised () {
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.getCartData.bind(this),
    )

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.BEFORE_ADD,
      this.hideAll.bind(this),
    )

    this.fetchProducts()
    this.getCartData()
  }

  async fetchProducts () {
    await Promise.allSettled(
      this.productHandlesWithAppliedLimit.map(productHandle => {
        return fetch(
          `${window.location.origin}/products/${productHandle}?section_id=${this.sectionId}`,
        )
          .then(res => res.text())
          .then(html => {
            const parsedHTML = new DOMParser().parseFromString(
              html,
              'text/html',
            )

            if (parsedHTML.querySelector('[data-mini-card]')) {
              this.handleFragmentInjection(parsedHTML)
            }
          })
          .catch(e => {
            console.error(e)
          })
      }),
    )
    this.initaliseCarousel()
  }

  async getCartData () {
    try {
      const response = await fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })

      if (!response.ok) {
        throw new Error('Failed to fetch cart data')
      }

      const cartData = await response.json()

      if (cartData.items.length === 0) {
        if (this.productHandles.length > 0) {
          this.show()
          this.externalEls.fallbackView.element.setAttribute(
            'aria-hidden',
            'true',
          )
        } else {
          this.hide()
          this.externalEls.fallbackView.element.setAttribute(
            'aria-hidden',
            'false',
          )
        }
      } else {
        this.hide()
        this.externalEls.fallbackView.element.setAttribute(
          'aria-hidden',
          'true',
        )
      }
    } catch (error) {
      console.error('Error:', error)
    }
  }

  /**
   * Initializes the carousel by cloning the carousel element, removing the original element,
   * and appending the cloned element to the current context.
   */

  initaliseCarousel () {
    const carousel = this.els.carousel.element.cloneNode({
      deep: true,
    })

    this.els.carousel.element.remove()

    this.appendChild(carousel)
  }

  /**
   * Handles the injection of HTML fragments by creating a temporary element,
   * setting the provided HTML as its innerHTML, and appending a specific element
   * from the temporary element to the target fragment injection element.
   *
   * @param {string} html - The HTML fragment to be injected.
   */

  handleFragmentInjection (html) {
    const el = document.createElement('li')
    el.classList.add('psh-EmptyCarousel_ListItem')
    el.innerHTML = html.querySelector(
      `#shopify-section-${this.sectionId}`,
    ).innerHTML

    this.els.fragmentinjection.element.insertAdjacentElement('beforeend', el)
  }

  /**
   * Handles an error by logging the error message to the console and calling the "hide" function.
   *
   * @param {string} message - The error message to be logged.
   */

  handleError (message) {
    console.error(message)
    this.hide()
  }

  show () {
    this.setAttribute('aria-hidden', 'false')
  }

  hide () {
    this.setAttribute('aria-hidden', 'true')
  }

  hideAll () {
    this.hide()
    this.externalEls.fallbackView.element.setAttribute('aria-hidden', 'true')
  }

  /**
   * Retrieves the product handles with the applied limit. If the number of product handles
   * exceeds the limit, it returns a subset of handles based on the limit; otherwise, it returns
   * all the product handles.
   *
   * @returns {string[]} - The product handles with the applied limit.
   */

  get productHandlesWithAppliedLimit () {
    if (this.productHandles.length > this.limit) {
      return this.productHandles.slice(0, this.limit)
    } else {
      return this.productHandles
    }
  }

  /**
   * Retrieves the limit value from the dataset attribute and returns it as a number.
   *
   * @returns {number} - The limit value.
   */

  get limit () {
    return Number(this.dataset.limit)
  }

  /**
   * Retrieves the product handles from the localStorage. If the handles are found in the localStorage,
   * it parses the JSON and returns them as an array. If the handles are not found, an empty array is returned.
   *
   * @returns {array[]} - The product handles retrieved from the localStorage.
   */

  get productHandles () {
    return JSON.parse(localStorage.getItem('recently-viewed-products')) || []
  }
}

customElements.define('push-cart-recently-viewed', PushCartRecentlyViewed)
